import { ConfigService } from '@stockcare-services/config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PerformanceMetricService } from '@stockcare-services/performance-metric-service/performance-metric-service';
import { Observable } from 'rxjs';
import { AnalyticsNames } from '@stockcare-helpers/analytics-names';
import { DoctorStorageService } from '@stockcare-storage/doctor/doctor-storage.service';
import { IDoctor } from '@stockcare-models/IDoctor';
import { Doctor } from '@stockcare-storage/doctor/doctor';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  doctors: Doctor[] = [];

  constructor(
    private http: HttpClient,
    private conf: ConfigService,
    private performanceMetricService: PerformanceMetricService,
    private doctorStorageService: DoctorStorageService
  ) {}

  ensureDoctorsLoaded() : Promise<boolean>{
    const hasDoctors = this.doctorStorageService.doctorsLoaded();
    return new Promise((resolve,reject)=>{
        if(!hasDoctors){
          this.getAll().subscribe(()=>resolve(true));
        }
        else{
          resolve(true);
        }
    });
  }
  getAll(): Observable<IDoctor[]> {
    const startTime = new Date();
    return new Observable((observer) => {
      this.http.get<IDoctor[]>(`${this.conf.config.baseUrl}/doctor/`).pipe(take(1)).subscribe(
        (result) => {
          this.addUpdateLocalDatabase(result).subscribe(() => {
            observer.next(result);
          });
          this.performanceMetricService.buildAndSubmitMetrics(startTime, AnalyticsNames.doctorListQuery);
        },
        (error) => observer.error(error)
      );
    });
  }

  private addUpdateLocalDatabase(doctors: IDoctor[]) {
    return new Observable((observer) => {
      const mappedDoctors = this.doctorStorageService.map(doctors);
      if (mappedDoctors && mappedDoctors.length > 0) {
        this.doctorStorageService.addDoctors(mappedDoctors).subscribe(() => {
          this.doctors = mappedDoctors;
          observer.next();
        });
      }
    });
  }
}
